module.exports = __webpack_public_path__ + "static/process2-9adab122ce0eccc9c3e3d2ad22f9015e.png";